<template>
  <div
    class="info-button-wrapper"
    ref="buttonRef"
    @mouseover="handleMouseOver"
    @mouseleave="handleMouseLeave"
  >
    <span class="info-icon" :class="type" role="img" :aria-label="type"></span>
    <teleport to="body">
      <PopoverMessage
        v-if="showPopover && messages.length > 0 && messages[0] !== ''"
        :messages="messages"
        :top="popoverTop"
        :left="popoverLeft"
        :arrow-left="arrowLeft"
        ref="popoverRef"
      />
    </teleport>
  </div>
</template>
<script setup lang="ts">
import { ref, nextTick } from 'vue'
import PopoverMessage from './PopoverMessage.vue'
defineProps<{ messages: string[]; type: string }>()
const showPopover = ref(false)
const popoverTop = ref(0)
const popoverLeft = ref(0)
const arrowLeft = ref(20)
const buttonRef = ref<HTMLElement | null>(null)
const popoverRef = ref<unknown>(null)
function handleMouseOver() {
  showPopover.value = true
  nextTick(() => {
    if (
      showPopover.value &&
      buttonRef.value &&
      popoverRef.value &&
      (popoverRef.value as { popoverRef: HTMLElement }).popoverRef
    ) {
      const buttonRect = buttonRef.value.getBoundingClientRect()
      const popoverRect = (
        popoverRef.value as { popoverRef: HTMLElement }
      ).popoverRef.getBoundingClientRect()
      const windowWidth = window.innerWidth
      const padding = 10

      popoverTop.value = buttonRect.top - popoverRect.height - 10

      const iconElement = buttonRef.value.querySelector('.info-icon') as HTMLElement
      let iconCenterX: number

      if (iconElement) {
        const iconRect = iconElement.getBoundingClientRect()
        iconCenterX = iconRect.left + iconRect.width / 2
      } else {
        iconCenterX = buttonRect.left + buttonRect.width / 2
      }

      let leftPosition = iconCenterX - popoverRect.width / 2

      if (leftPosition + popoverRect.width > windowWidth - padding) {
        leftPosition = windowWidth - popoverRect.width - padding
      }

      if (leftPosition < padding) {
        leftPosition = padding
      }

      let calculatedArrowLeft = iconCenterX - leftPosition - 10

      const minArrowLeft = 10
      const maxArrowLeft = popoverRect.width - 20
      if (calculatedArrowLeft < minArrowLeft) {
        calculatedArrowLeft = minArrowLeft
      } else if (calculatedArrowLeft > maxArrowLeft) {
        calculatedArrowLeft = maxArrowLeft
      }

      popoverLeft.value = leftPosition
      arrowLeft.value = calculatedArrowLeft
    }
  })
}
function handleMouseLeave() {
  showPopover.value = false
}
</script>
<script lang="ts">
export default {
  name: 'InfoButton',
}
</script>
<style scoped>
.info-button-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.info-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-image: url('@/assets/info-icon.svg');
  mask-image: url('@/assets/info-icon.svg');
  vertical-align: middle;
}

.info-icon.info {
  background-color: #c5c5c5;
}
.info-icon.error {
  background-color: #d32f2f;
}
.info-icon.ERROR {
  background-color: #d32f2f;
}

.info-icon.LEGACY {
  background-color: #616469;
}
.info-icon.REGISTERED {
  background-color: #3f7623;
  -webkit-mask-image: url('@/assets/succes-padlock-icon.svg');
  mask-image: url('@/assets/succes-padlock-icon.svg');
}
.info-icon.NOT_REGISTERED {
  background-color: #003ea7;
}
.info-icon.NOT_REGISTERED_EDITED {
  background-color: #44587a;
  -webkit-mask-image: url('@/assets/pencil-icon-no-registered.svg');
  mask-image: url('@/assets/pencil-icon-no-registered.svg');
}
.info-icon.ERROR_EDITED {
  background-color: #733f3f;
  -webkit-mask-image: url('@/assets/pencil-icon-error.svg');
  mask-image: url('@/assets/pencil-icon-error.svg');
}

/* Delivery Status Types */
.info-icon.ABIERTO {
  background-color: #4eab1f;
}
.info-icon.RECIBIDO {
  background-color: #003896;
}
.info-icon.RECHAZADO {
  background-color: #eb9947;
}
.info-icon.INEXISTENTE {
  background-color: #d0342c;
}
.info-icon.SPAM {
  background-color: #d0342c;
}
.info-icon.ENVIANDO {
  background-color: #6b6b6b;
}

/* Membership Status Types */
.info-icon.Vigente {
  background-color: #3f7623;
  -webkit-mask-image: url('@/assets/ok-icon.svg');
  mask-image: url('@/assets/ok-icon.svg');
}

.info-icon.Suspendida {
  background-color: #916c29;
  -webkit-mask-image: url('@/assets/triangle-info-yellow.svg');
  mask-image: url('@/assets/triangle-info-yellow.svg');
}

.info-icon.Cancelada {
  background-color: #a83535;
  -webkit-mask-image: url('@/assets/info-icon.svg');
  mask-image: url('@/assets/info-icon.svg');
}

.info-icon.Aprobacion,
.info-icon.Aprobación {
  background-color: #fafafa;
  -webkit-mask-image: url('@/assets/warning-blue-icon.svg');
  mask-image: url('@/assets/warning-blue-icon.svg');
}

.info-icon.Completada {
  background-color: #003ea7;
  -webkit-mask-image: url('@/assets/warning-blue-icon.svg');
  mask-image: url('@/assets/warning-blue-icon.svg');
}

.popover {
  position: fixed;
  min-width: 220px;
  background: #fff;
  color: #333;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  z-index: 9999;
  font-size: 1rem;
  border: 1px solid #eee;
}
.popover:before {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 20px;
  border-width: 10px 10px 0 10px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}
</style>
